import MinimizeButton from "../atoms/buttons/MinimizeButton.jsx";
import CloseButton from "../atoms/buttons/CloseButton.jsx";
import HLBLogo from "../atoms/images/HLBLogo.jsx";
import HLISBLogo from "../atoms/images/HLISBLogo.jsx";

export default function Header () {

    return (
        <div className="header">
            <div className="header-logo">
                <HLBLogo/>
                <HLISBLogo/>
            </div>
            <div className="header-buttons">
                <MinimizeButton/>
                <CloseButton/>
            </div>
        </div>
    );
};
